import Vue from 'vue'
import Login from '../views/Login'
import Dashboard from '../views/Dashboard'
import VueRouter from 'vue-router'
import store from '../store'
import Posts from "../views/Posts";
import Post from "../views/Post";
import Ingredients from "../views/Ingredients";

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Login,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/posts',
          name: 'Posts',
          component: Posts,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/posts/edit',
          name: 'Post editieren',
          component: Post,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/posts/new',
          name: 'Neuer Post',
          component: Post,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/ingredients',
          name: 'Zutaten',
          component: Ingredients,
          meta: {
            requiresAuth: true
          }
        }
      ],
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})